module.exports = __webpack_public_path__ + "static/media/COMENT_ICON.726ab150.svg";